import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import { timeFromNow } from '../../util/date';
import CollapseCustomerContact from './CollapseCustomerContact';
import CollapseRelatedTicket from './CollapseRelatedTicket';
import CollapseInformationFromSales from './CollapseInformationFromSales';
import { CheckPermissionComponent } from '../../util/permission';
import { TICKET_LIST_ALL_CONTACT_INSERT, TICKET_LIST_ALL_CONTACT_INSERT_ASSIGNEE } from '../../constants/menuPermissionConstant';

class TicketPhoneSideInside extends Component {
    render() {
        return (
            <div className="bg-white rounded-md overflow-y-auto px-6 py-8 h-full">
                <div className="flex items-start">
                    <div className="bg-darkblue text-white flex items-center justify-center rounded-full font-bold box-lg">{this.props.data.customer?.charAt(0)}</div>
                    <div className="ml-2">
                        <p>{this.props.data.customer} melaporkan via Telepon</p>
                        <p className="text-xs">{timeFromNow(this.props.data.open_at, this.props.serverTime)} ({moment.utc(this.props.data.created_at).format('ddd, DD MMMM YYYY')} di jam {moment.utc(this.props.data.created_at).format('HH:mm')})</p>
                    </div>
                </div>
                <div className="flex items-center justify-between text-xs p-5 border-b-2 border-gray-500">
                    <div className="text-left">
                        <p className="mb-1">CS</p>
                        <p className="mb-1">PIC</p>
                        <p>Telepon PIC</p>
                    </div>
                    <div className="text-right">
                        <p className="mb-1 truncate" style={{ maxWidth: "180px" }} title={this.props.data.cs}>{this.props.data.cs === undefined || this.props.data.cs === '' ? '-' : this.props.data.cs}</p>
                        <p className="mb-1 truncate" style={{ maxWidth: "180px" }} title={this.props.data.pic_name}>{this.props.data.pic_name === undefined || this.props.data.pic_name === '' ? '-' : this.props.data.pic_name}</p>
                        <p>{this.props.data.pic_phone === undefined || this.props.data.pic_phone === '' ? '-' : `${this.props.data.country_code}${this.props.data.pic_phone}`}</p>
                    </div>
                </div>
                {
                    this.props.data?.id !== undefined &&
                    <div>
                        <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_CONTACT_INSERT, TICKET_LIST_ALL_CONTACT_INSERT_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                            <CollapseCustomerContact data={this.props.data} />
                        </CheckPermissionComponent>
                        <CollapseRelatedTicket data={this.props.data} />
                        <CollapseInformationFromSales data={this.props.data} />
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userDetail: state.authentication.userDetail
    };
};

export default connect(mapStateToProps, null)(TicketPhoneSideInside);